module.exports = __webpack_public_path__ + "media/images/settings_active-8fa7eb9dabec7043eb619a7855ab5c4d.svg";